import { getApiClient } from './authApiClient';
import { DNB_IDENTITY_SEARCH_TENANT_ID } from '../config/dnbIdentitySearchRollout';

const base = '/dnb/identity-batches';
const identifier = value => typeof value === 'string' && /^[A-Za-z0-9_.-]{1,100}$/.test(value);
const scope = tenantId => {
  if (tenantId !== DNB_IDENTITY_SEARCH_TENANT_ID) throw new Error('Company identity batches are not available for this account.');
  return { tenantId };
};
const path = id => {
  if (!identifier(id)) throw new Error('Choose a saved identity batch.');
  return `${base}/${encodeURIComponent(id)}`;
};
const unwrap = response => {
  if (response?.data?.success !== true || !response.data.data || typeof response.data.data !== 'object') throw new Error('The saved batch response could not be verified.');
  return response.data.data;
};
const options = (tenantId, signal) => ({ params: scope(tenantId), signal, timeout: 45000, _retry: true });

export async function listIdentityBatches(tenantId, { signal } = {}) {
  return unwrap(await getApiClient('company').get(base, options(tenantId, signal)));
}
export async function getIdentityBatch(tenantId, id, { signal } = {}) {
  return unwrap(await getApiClient('company').get(path(id), options(tenantId, signal)));
}
export async function createIdentityBatch(tenantId, payload, { signal } = {}) {
  if (!identifier(payload?.requestId)) throw new Error('A stable save identifier is required.');
  return unwrap(await getApiClient('company').post(base, payload, options(tenantId, signal)));
}
export async function updateIdentityBatch(tenantId, id, action, requestId, { signal, queryId } = {}) {
  if (!['next', 'pause', 'resume', 'cancel', 'retry'].includes(action) || !identifier(requestId) || (action === 'retry' && !identifier(queryId))) throw new Error('Invalid batch action.');
  // _retry=true disables the shared client's automatic authentication replay.
  // Unknown POST outcomes must be reconciled with GET, never repeated here.
  return unwrap(await getApiClient('company').post(`${path(id)}/${action}`, action === 'retry' ? { requestId, queryId } : { requestId }, { ...options(tenantId, signal), timeout: action === 'next' ? 90000 : 45000 }));
}
export async function exportIdentityBatch(tenantId, id, format, { signal } = {}) {
  if (!['json', 'csv'].includes(format)) throw new Error('Choose JSON or CSV.');
  const config = options(tenantId, signal);
  config.params.format = format;
  return unwrap(await getApiClient('company').get(`${path(id)}/export`, config));
}
